var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Danger = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsxs("svg", __assign({ width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: [_jsx("path", { d: 'M4.95221 16.3536L10.2152 5.85658C10.9531 4.38481 13.0539 4.3852 13.7913 5.85723L19.0495 16.3543C19.7156 17.6841 18.7487 19.25 17.2613 19.25H6.74008C5.25235 19.25 4.28541 17.6835 4.95221 16.3536Z', stroke: '#E63B39', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }), _jsx("path", { d: 'M12 10V12', stroke: '#E63B39', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }), _jsx("path", { d: 'M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16Z', stroke: '#E63B39' })] })));
};
export { Danger };
//# sourceMappingURL=Danger.js.map